module.exports = __webpack_public_path__ + "img/impulsesv-2cd44408-42a5-4cdd-ddf4-08d959eef549.png";